/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import styled from "styled-components";
import { fontSizeMap as textFontSizeMap, fontWeightMap as textFontWeightMap } from "../../components/Text/Text.style.js";
import { ITheme } from "../../components/Theme/Theme.types.js";
import { StyleDefaultNavItemProps } from "./NavItem.types.js";

const getColor = ({ disabled, selected, theme }: { disabled?: boolean; selected?: boolean; theme: ITheme }) => {
    if (disabled) return theme.grayscale[70];
    if (selected) return theme.colors.primary[100];
    return theme.grayscale[80];
};

export default styled.div<StyleDefaultNavItemProps>`
    color: ${(props) =>
        getColor({
            disabled: props.disabled,
            selected: props.selected,
            theme: props.theme,
        })};
    font-size: ${(props) => props.theme.rem(textFontSizeMap["x-small"])};
    font-weight: ${textFontWeightMap.bold};
    padding: ${(props) => `${props.theme.spacing[12]}`};
    border-radius: ${(props) => props.theme.radius.xs};
    background-color: ${(props) => (props.selected ? props.theme.grayscale.white : "none")};
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};

    &:hover {
        background-color: ${(props) => !props.disabled && !props.selected && "rgba(255, 255, 255, 0.4)"};
    }

    &:focus {
        outline: none;
    }

    & * {
        vertical-align: middle;
    }
`;
